import { BuildingType } from '../../Plants/Buildings/P_Building/types';
import { IAutomationObject } from '../../types'

export interface IEnergyOverview extends IAutomationObject {
    buildingType: BuildingType;
    squereMeter: number;
    co2Current: number;
    co2Heat: number;
    co2Cold: number;
    co2Gas: number;
    co2Fuel: number;
    co2Water: number;
    actCostsCurrent: number;
    actCostsHeat: number;
    actCostsCold: number;
    actCostsGas: number;
    actCostsFuel: number;
    actCostsWater: number;
    currencyCode: string | undefined;
}

export const schema = 'AutomationApps.Utils.EnergyOverview';
 